import React, { useState, useEffect } from 'react';
import { isAuthenticated } from '../../../auth';
import { getContent } from '../helper/api';
import { startLoader, stopLoader } from '../../../lib/utils';
import "../style.scss";

const ContentView = (props) => {

    const ContentId = props.selectedContentId;
    const [currentVideo, setCurrentVideo] = useState(0);
    const { user, token } = isAuthenticated();
    const [Content, setContent] = useState("");
    const [isContentActionVisible, setContentActionVisible] = useState(false);
    const [isMusclesPreviewOpen, setMusclesPreviewOpen] = useState(false);
    const [currentMuscleIndex, setCurrentMuscleIndex] = useState(0);
    const [musclesList, setMusclesList] = useState([]);
    // NEW: controls which tab is active on mobile ("steps" | "muscles")
    const [mobileContentTab, setMobileContentTab] = useState("steps");

    const handleCurrentVideo = (index) => {
      if (index > -1 && index < (Content.videoList.length)) {
        setCurrentVideo(index);
      }
    }

    const handleCurrentMuscle = (index) => {
      if (index > -1 && index < (musclesList.length)) {
        setCurrentMuscleIndex(index);
      }
    }

    const GetContent = async () => {
      try {
        let response = await getContent(user._id, token, ContentId);
        if (!response.error) {
          setContent(response)
          if (response.videoList && response.videoList.length) {
            setCurrentVideo(0)
          }


          setMusclesList(oldMuscles => {
            const primary = (response.primaryMuscles || []).map(muscle => ({
              muscleName: muscle.name,
              type: "primary"
            }));

            const secondary = (response.secondaryMuscles || []).map(muscle => ({
              muscleName: muscle.name,
              type: "secondary"
            }));

            return [...oldMuscles, ...primary, ...secondary];
          });

        }
      } catch (error) {
        //do something
      }
    }

    const toggleContentActionVisible = (value) => {
      setContentActionVisible(value);
    }

    const toggleMusclePreview = (value) => {
      if(value){
        const index = musclesList.findIndex(
          muscle => muscle.muscleName === value
        );
        if(index != -1){
          setCurrentMuscleIndex(index)
        }
        setMusclesPreviewOpen(true)
      }else{
        setCurrentMuscleIndex(0);
        setMusclesPreviewOpen(false);
      }
    }

    useEffect(() => {
      if (document.getElementById("steps-conatiners-identifier-last-child")) {
        let height = document.getElementById("steps-conatiners-identifier").offsetHeight;
      }
    }, [document.getElementById("steps-conatiners-identifier-last-child")])


    useEffect(async () => {
      try {
        await startLoader();
        await GetContent();
        await stopLoader();
      } catch (error) {
        await stopLoader()
      }
    }, [])

    return (
      <div onClick={()=>props.toggleContentPreview()} className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`} style={{borderRadius: window.innerWidth < 640 ? "12px 12px 0 0" : ""}}>
        <div onClick={(e)=>e.stopPropagation()}  className="modal-container flex-item" style={{width: window.innerWidth > 767 ? "70%" : "100%", height: window.innerWidth > 767 ? "88%" : "100%", position:"relative", overflowY: window.innerWidth > 767 ? "visible" : "auto"}}>
          <div className='content-video-container' style={{width:"100%", height: window.innerWidth > 767 ? "79.5%" : "220px"}}>
            <div onMouseOver={()=>!isMusclesPreviewOpen && toggleContentActionVisible(true)} onMouseLeave={()=>!isMusclesPreviewOpen && toggleContentActionVisible(false)} className="w-full h-full" style={{ height: "100%", position: 'relative' }}>
              {
                isContentActionVisible && (
                  <div className='content-action-header space-between d-flex'>
                    <div className='flex-item'>
                      <p className='fs-20 color-white font-weight-700 m-b-16 m-t-8'>{Content.videoList && Content.videoList[currentVideo] && Content.videoList[currentVideo].title}</p>
                      {
                        Content && Content.videoList && Content.videoList.length > 1 && (
                          <div className='d-flex'>
                            <div onClick={() => handleCurrentVideo(currentVideo - 1)} className="next-prev-button cursor-pointer d-flex" style={{ background: currentVideo == 0 ? "#000000" : currentVideo > 0 && currentVideo <= Content.videoList.length - 1 ? "var(--darkBlue)" : "#000000" }}>
                              <svg className="flex-item margin-auto" width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7 1L1 5.81481L7 11" stroke="white" stroke-linecap="round" />
                              </svg>
                            </div>
                            <p className='flex-item m-l-12 m-r-12 font-weight-700' style={{color:"#C3E8FF"}}>{currentVideo + 1} of {Content.videoList.length}</p>
                            <div onClick={() => handleCurrentVideo(currentVideo + 1)} className="next-prev-button cursor-pointer d-flex" style={{ background: currentVideo == 0 ? "#000000" : currentVideo > 0 && currentVideo <= Content.videoList.length - 1 ? "var(--darkBlue)" : "#000000" }}>
                              <svg className="flex-item margin-auto" width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 11L7 6.18519L1 1" stroke="white" stroke-linecap="round" />
                              </svg>
                            </div>
                          </div>
                        )
                      }
                    </div>
                    <div onClick={()=>props.toggleContentPreview()} className="d-flex desktop-modal-close-button" style={{width: "40px", height:"40px", alignSelf:"flex-start", background:"var(--red)"}}>
                      <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="#ffffff" />
                      </svg>
                    </div>
                  </div>
                )
              }
              <iframe className="exercise-video-container" style={{height:"100%", width:"100%", borderRadius: window.innerWidth > 767 ? "20px 20px 0 0" : "0"}} src={Content && Content.videoList && Content.videoList.length && currentVideo > -1 && Content.videoList[currentVideo].link}/>
            </div>
          </div>

          {
            window.innerWidth > 767 ? (
              /* ===================== DESKTOP VIEW */
              <div className='d-flex space-between w-full' style={{padding:"12px 16px", height:"21%"}}>
                <div className='flex-item h-full p-r-12' style={{width:'60%', alignSelf:"flex-start", position:"relative"}}>
                  <p className='flex-item fs-18 font-weight-600'>Instruction</p>
                  <div className='w-full' style={{maxHeight:"50%", overflowY:"auto", alignItems:"flex-start"}}>
                    <p className='flex-item fs-15 m-t-6 color-dark-blue p-r-12' style={{fontWeight:"700", lineHeight:"20px", color: Content.instructions == "" && "#9a9a9a" }}>{Content.instructions ? Content.instructions : "No Instruction Found"}</p>
                  </div>
                  <p className='flex-item fs-14 color-grey-07' style={{position:"absolute", bottom: 0, left: 0}}>©2025 WorkoutPlus, Gymshim</p>
                </div>
                <svg className='flex-item' width="1" height="100%" viewBox="0 0 1 215" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <line x1="0.5" x2="0.5" y2="215" stroke="#A1A1A1"/>
                </svg>
                <div className='flex-item h-full p-l-16' style={{width:'40%', alignSelf:"flex-start"}}>
                  <div className='flex-item m-t-8 d-flex-wrap no-scroll-bar p-l-6' style={{maxHeight:"90%", overflowY:"scroll", alignItems:"flex-start"}}>
                    {
                      Content && Content.primaryMuscles.length > 0 && Content.primaryMuscles.map(data => {
                        return(
                          <div onClick={()=>toggleMusclePreview(data.name)} className='d-flex space-between m-b-6 m-r-6 muscles-list-container' style={{backgroundColor:"#6A1B9A" }}>
                            <p className='flex-item color-white font-weight-600 m-r-20' style={{width:"80%"}}>{data.name}</p>
                            <svg style={{alignSelf:"flex-start"}} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5.02504 13.602C5.73081 10.327 8.6812 8 12 8C15.3188 8 18.2682 10.327 18.975 13.602C19.003 13.732 19.0832 13.8458 19.1981 13.9186C19.313 13.9914 19.4531 14.0171 19.5876 13.99C19.7221 13.9629 19.8399 13.8854 19.9152 13.7744C19.9905 13.6633 20.0171 13.528 19.9891 13.398C19.185 9.673 15.8217 7 12 7C8.17826 7 4.81496 9.673 4.01087 13.398C3.98288 13.528 4.00945 13.6633 4.08475 13.7744C4.16005 13.8854 4.27791 13.9629 4.4124 13.99C4.54688 14.0171 4.68698 13.9914 4.80188 13.9186C4.91677 13.8458 4.99704 13.732 5.02504 13.602ZM11.9897 10C12.9503 10 13.8715 10.3687 14.5508 11.0251C15.2301 11.6815 15.6117 12.5717 15.6117 13.5C15.6117 14.4283 15.2301 15.3185 14.5508 15.9749C13.8715 16.6313 12.9503 17 11.9897 17C11.029 17 10.1078 16.6313 9.4285 15.9749C8.74924 15.3185 8.36764 14.4283 8.36764 13.5C8.36764 12.5717 8.74924 11.6815 9.4285 11.0251C10.1078 10.3687 11.029 10 11.9897 10Z" fill="white"/>
                            </svg>
                          </div>
                        )
                      })
                    }
                    {
                      Content && Content.secondaryMuscles.length > 0 && Content.secondaryMuscles.map(data => {
                        return(
                          <div onClick={()=>toggleMusclePreview(data.name)} className='flex-item d-flex space-between m-b-6 m-r-6 muscles-list-container' style={{backgroundColor:"#26A69A"}}>
                            <p className='flex-item color-white font-weight-600 m-r-20' style={{width:"80%"}}>{data.name}</p>
                            <svg style={{alignSelf:"flex-start", minWidth:"24px", minHeight:"24px"}} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5.02504 13.602C5.73081 10.327 8.6812 8 12 8C15.3188 8 18.2682 10.327 18.975 13.602C19.003 13.732 19.0832 13.8458 19.1981 13.9186C19.313 13.9914 19.4531 14.0171 19.5876 13.99C19.7221 13.9629 19.8399 13.8854 19.9152 13.7744C19.9905 13.6633 20.0171 13.528 19.9891 13.398C19.185 9.673 15.8217 7 12 7C8.17826 7 4.81496 9.673 4.01087 13.398C3.98288 13.528 4.00945 13.6633 4.08475 13.7744C4.16005 13.8854 4.27791 13.9629 4.4124 13.99C4.54688 14.0171 4.68698 13.9914 4.80188 13.9186C4.91677 13.8458 4.99704 13.732 5.02504 13.602ZM11.9897 10C12.9503 10 13.8715 10.3687 14.5508 11.0251C15.2301 11.6815 15.6117 12.5717 15.6117 13.5C15.6117 14.4283 15.2301 15.3185 14.5508 15.9749C13.8715 16.6313 12.9503 17 11.9897 17C11.029 17 10.1078 16.6313 9.4285 15.9749C8.74924 15.3185 8.36764 14.4283 8.36764 13.5C8.36764 12.5717 8.74924 11.6815 9.4285 11.0251C10.1078 10.3687 11.029 10 11.9897 10Z" fill="white"/>
                            </svg>
                          </div>
                        )
                      })
                    }

                    {
                      musclesList.length == 0 && (
                        <p className='fs-16 font-weight-600' style={{marginTop:"-4px"}}>Please Add Exercise Muscles.</p>
                      )
                    }
                  </div>
                </div>
              </div>
            ) : (
              /* ===================== MOBILE VIEW */
              <div className='w-full' style={{padding:"16px 16px 24px 16px"}}>

                <p className='fs-18 font-weight-700 color-dark-blue m-b-16' style={{textTransform:"uppercase", lineHeight:"22px"}}>
                  {Content.name}
                </p>

                <div className='d-flex m-b-20'>
                  <div
                    onClick={()=>setMobileContentTab("steps")}
                    className={`global-button-container d-flex flex-item p-l-16 p-r-16 m-r-12 ${mobileContentTab === "steps" ? "global-button-container-active" : ""}`}
                  >
                    <p className='flex-item'>Exercise Steps</p>
                  </div>
                  <div
                    onClick={()=>setMobileContentTab("muscles")}
                    className={`global-button-container d-flex flex-item p-l-16 p-r-16 ${mobileContentTab === "muscles" ? "global-button-container-active" : ""}`}
                    style={mobileContentTab !== "muscles" ? {border: "1px solid #BABABA"} : {}}
                  >
                    <p className='flex-item'>Target Muscles</p>
                  </div>
                </div>

                {
                  mobileContentTab === "steps" ? (
                    <div>
                      <p className='fs-16 font-weight-700 color-black m-b-8'>Exercise Level</p>
                      <div className='m-b-20'>
                        {
                          (Content.exerciseLevels && Content.exerciseLevels.length > 0) ? Content.exerciseLevels.map(data => (
                            <div className='d-flex m-b-4'>
                              <div className='flex-item dot-icon m-r-6' />
                              <p className='flex-item fs-14' style={{color:"#7D7A7A"}}>{data.name}</p>
                            </div>
                          )) : (
                            <p className='fs-14' style={{color:"#7D7A7A"}}>No Exercise Level Selected</p>
                          )
                        }
                      </div>

                      <p className='fs-16 font-weight-700 color-black m-b-8'>Exercise Type</p>
                      <div className='m-b-20'>
                        {
                          (Content.exerciseTypes && Content.exerciseTypes.length > 0) ? Content.exerciseTypes.map(data => (
                            <div className='d-flex m-b-4'>
                              <div className='flex-item dot-icon m-r-6' />
                              <p className='flex-item fs-14' style={{color:"#7D7A7A"}}>{data.name}</p>
                            </div>
                          )) : (
                            <p className='fs-14' style={{color:"#7D7A7A"}}>No Exercise Type Selected</p>
                          )
                        }
                      </div>

                      <p className='fs-16 font-weight-700 color-black m-b-8'>Instructions</p>
                      <p className='fs-14' style={{lineHeight:"20px", color:"#7D7A7A"}}>
                        {Content.instructions ? Content.instructions : "No Instruction Found"}
                      </p>

                      <p className='fs-12 color-grey-07 m-t-20'>©2025 WorkoutPlus, Gymshim</p>
                    </div>
                  ) : (
                    <div className='d-flex-wrap w-full'>
                      {
                        Content && Content.primaryMuscles && Content.primaryMuscles.length > 0 && Content.primaryMuscles.map(data => {
                          return(
                            <div onClick={()=>toggleMusclePreview(data.name)} className='d-flex space-between m-b-6 m-r-6 muscles-list-container' style={{backgroundColor:"#6A1B9A" }}>
                              <p className='flex-item color-white font-weight-600 m-r-20' style={{width:"80%"}}>{data.name}</p>
                              <svg style={{alignSelf:"flex-start"}} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.02504 13.602C5.73081 10.327 8.6812 8 12 8C15.3188 8 18.2682 10.327 18.975 13.602C19.003 13.732 19.0832 13.8458 19.1981 13.9186C19.313 13.9914 19.4531 14.0171 19.5876 13.99C19.7221 13.9629 19.8399 13.8854 19.9152 13.7744C19.9905 13.6633 20.0171 13.528 19.9891 13.398C19.185 9.673 15.8217 7 12 7C8.17826 7 4.81496 9.673 4.01087 13.398C3.98288 13.528 4.00945 13.6633 4.08475 13.7744C4.16005 13.8854 4.27791 13.9629 4.4124 13.99C4.54688 14.0171 4.68698 13.9914 4.80188 13.9186C4.91677 13.8458 4.99704 13.732 5.02504 13.602ZM11.9897 10C12.9503 10 13.8715 10.3687 14.5508 11.0251C15.2301 11.6815 15.6117 12.5717 15.6117 13.5C15.6117 14.4283 15.2301 15.3185 14.5508 15.9749C13.8715 16.6313 12.9503 17 11.9897 17C11.029 17 10.1078 16.6313 9.4285 15.9749C8.74924 15.3185 8.36764 14.4283 8.36764 13.5C8.36764 12.5717 8.74924 11.6815 9.4285 11.0251C10.1078 10.3687 11.029 10 11.9897 10Z" fill="white"/>
                              </svg>
                            </div>
                          )
                        })
                      }
                      {
                        Content && Content.secondaryMuscles && Content.secondaryMuscles.length > 0 && Content.secondaryMuscles.map(data => {
                          return(
                            <div onClick={()=>toggleMusclePreview(data.name)} className='flex-item d-flex space-between m-b-6 m-r-6 muscles-list-container' style={{backgroundColor:"#26A69A"}}>
                              <p className='flex-item color-white font-weight-600 m-r-20' style={{width:"80%"}}>{data.name}</p>
                              <svg style={{alignSelf:"flex-start", minWidth:"24px", minHeight:"24px"}} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.02504 13.602C5.73081 10.327 8.6812 8 12 8C15.3188 8 18.2682 10.327 18.975 13.602C19.003 13.732 19.0832 13.8458 19.1981 13.9186C19.313 13.9914 19.4531 14.0171 19.5876 13.99C19.7221 13.9629 19.8399 13.8854 19.9152 13.7744C19.9905 13.6633 20.0171 13.528 19.9891 13.398C19.185 9.673 15.8217 7 12 7C8.17826 7 4.81496 9.673 4.01087 13.398C3.98288 13.528 4.00945 13.6633 4.08475 13.7744C4.16005 13.8854 4.27791 13.9629 4.4124 13.99C4.54688 14.0171 4.68698 13.9914 4.80188 13.9186C4.91677 13.8458 4.99704 13.732 5.02504 13.602ZM11.9897 10C12.9503 10 13.8715 10.3687 14.5508 11.0251C15.2301 11.6815 15.6117 12.5717 15.6117 13.5C15.6117 14.4283 15.2301 15.3185 14.5508 15.9749C13.8715 16.6313 12.9503 17 11.9897 17C11.029 17 10.1078 16.6313 9.4285 15.9749C8.74924 15.3185 8.36764 14.4283 8.36764 13.5C8.36764 12.5717 8.74924 11.6815 9.4285 11.0251C10.1078 10.3687 11.029 10 11.9897 10Z" fill="white"/>
                              </svg>
                            </div>
                          )
                        })
                      }

                      {
                        musclesList.length == 0 && (
                          <p className='fs-16 font-weight-600' style={{marginTop:"-4px"}}>Please Add Exercise Muscles.</p>
                        )
                      }
                    </div>
                  )
                }
              </div>
            )
          }

          {
            isMusclesPreviewOpen && (
              <div className='muscle-previewer-container'>
                <div onClick={()=>toggleMusclePreview()} className="d-flex desktop-modal-close-button" style={{width: "40px", height:"40px", alignSelf:"flex-start", background:"var(--red)", margin:"0 0 0 auto", position:"absolute", right:20, top:16}}>
                  <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="#ffffff" />
                  </svg>
                </div>

                <div className='d-flex w-full h-full'>
                  <div className='flex-item margin-auto'>
                    <div className='d-flex margin-auto'>
                      <div onClick={()=>handleCurrentMuscle(currentMuscleIndex - 1)} className='flex-item d-flex prev-next-muscles-btn cursor-pointer'>
                        <svg className='flex-item m-l-18' width="20" height="20" viewBox="0 0 29 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M25.9492 38.5L3.94922 21.3372L25.9492 2.5" stroke="white" stroke-width="5" stroke-linecap="round"/>
                        </svg>
                      </div>
                      <div className='flex-item muscle-view-container m-l-20 m-r-20'>
                        <img className='muscle-image' src={`https://workoutplus.gymshim.com/api/wp-content-muscle-image?name=${musclesList[currentMuscleIndex].muscleName}&${Date.now()}`} />
                        <div className='muscle-name-container d-flex' style={{backgroundColor: musclesList[currentMuscleIndex].type == "primary" ? "#6A1B9A" : "#26A69A"}}>
                          <p className='flex-item margin-auto color-white'>{musclesList[currentMuscleIndex].muscleName}</p>
                        </div>
                      </div>
                      <div onClick={()=>handleCurrentMuscle(currentMuscleIndex + 1)} className='flex-item prev-next-muscles-btn d-flex cursor-pointer'>
                        <svg className='flex-item m-l-22' width="20" height="20" viewBox="0 0 28 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.5 2.5L23.5 19.6628L2.5 38.5" stroke="white" stroke-width="5" stroke-linecap="round"/>
                        </svg>
                      </div>
                    </div>
                    <div className='d-flex m-t-16'>
                      <div className='margin-auto d-flex'>
                        <p className='font-weight-600 color-white flex-item'>Target Muscles</p>
                        <svg className='flex-item m-l-12 m-r-12' width="1" height="22" viewBox="0 0 1 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <line x1="0.5" y1="0.5" x2="0.5" y2="20.7294" stroke="#E33A34" stroke-linecap="round"/>
                        </svg>
                        <div className='flex-item d-flex m-r-12'>
                          <svg className='flex-item m-r-6' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="9.64974" cy="9.64974" r="9.64974" fill="#6A1B9A"/>
                          </svg>
                          <p className='font-weight-600 color-white flex-item'>Primary</p>
                        </div>
                        <div className='flex-item d-flex'>
                          <svg className='flex-item m-r-6' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="9.64974" cy="9.64974" r="9.64974" fill="#26A69A"/>
                          </svg>
                          <p className='font-weight-600 color-white flex-item'>Secondary</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            )
          }
        </div>
      </div>
    )

}

export default ContentView;